export default __webpack_public_path__ + "static/coleg-fedf4f56b826f32ac55a60bcf2b46e75.png";